import { arrayMove } from '@dnd-kit/sortable';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	Stack,
} from '@mui/material';
import { closeSnackbar, useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DndArticleListSection from './info-order/DndArticleListSection';
import CloseIcon from '@mui/icons-material/Close';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import {
	useGetMomentListQuery,
	useSortMomentListMutation,
} from '@/api/app-setting/momentApiSlice';

interface Props {}

export default function SetOrderDialog(props: Props) {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [open, setOpen] = useState(false);
	const [sortMomentList] = useSortMomentListMutation();

	const [items, setItems] = useState<any>([]);

	const { data: propertySummary, isSuccess: isGetPropertySummarySuccess } =
		useGetMomentListQuery(
			{
				pagination: { page: 1, size: 1000000 },
				searchString: '',
				sortings: [],
			},
			{
				refetchOnMountOrArgChange: true,
				skip: !open,
			}
		);

	useEffect(() => {
		setItems(propertySummary?.data?.items ?? []);
	}, [isGetPropertySummarySuccess, propertySummary]);

	const handleRepositionItem = (activeIndex: number, overIndex: number) => {
		setItems((prev: unknown[]) => arrayMove(prev, activeIndex, overIndex));
	};

	const onSubmit = async () => {
		const data: any[] = [];
		items.forEach((item: { id: string }, index: number) => {
			data.push({
				id: item.id,
				sort: index,
			});
		});
		const response = await sortMomentList({ sortList: data });
		if ('data' in response) {
			enqueueSnackbar(t('snackbar.sortSuccess'), {
				variant: 'success',
				anchorOrigin: { horizontal: 'center', vertical: 'top' },
				autoHideDuration: 3000,
				action: (key) => {
					return <CloseIcon onClick={() => closeSnackbar(key)} />;
				},
			});
			handleClose();
		}
	};

	const handleClose = () => {
		setOpen(false);
	};

	const formContent = (
		<>
			<Button
				variant='contained'
				style={{ alignItems: 'center' }}
				endIcon={<FormatLineSpacingIcon />}
				onClick={() => setOpen(true)}
			>
				{t('moment.rearrangement')}
			</Button>
			<Dialog
				open={open}
				onClose={() => handleClose()}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='lg'
				fullWidth
			>
				<DialogTitle variant='h5'>{t('moment.rearrangement')}</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={() => handleClose()}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent>
					<Grid container alignItems='stretch' columnSpacing={3} marginTop={3}>
						<Grid item xs display='flex'>
							<Stack>
								{items && (
									<DndArticleListSection
										items={items}
										handleRepositionItem={handleRepositionItem}
									/>
								)}
							</Stack>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose()}>{t('button.cancel')}</Button>

					<Button type='submit' variant='contained' onClick={() => onSubmit()}>
						{t('button.save')}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
	return <>{formContent}</>;
}
